export default function listServiceProducts(
  service: any,
  products: any[]
): any[] {
  const list = products.filter((item) => {
    return item.product.services.includes(service.id);
  });
  return list.map((item) => item.product);
}
